import { HttpErrorResponse, type HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { SKIP_AUTH } from "../../api/skip-auth.context";
import { AuthStore } from "../persistence/auth.store";
import { catchError, throwError } from "rxjs";

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
    const authStore = inject(AuthStore);

    const token = authStore.token();

    if (token && !req.context.get(SKIP_AUTH)) {
        req = req.clone({
            setHeaders: { Authorization: `Bearer ${token}` },
        });
    }

    return next(req).pipe(
        catchError((err) => {
            if (err instanceof HttpErrorResponse) {
                switch (err.status) {
                    case 401:
                        authStore.logout();

                        window.location.href = "/account/logout";
                        break;
                }
            }
            return throwError(() => err);
        }),
    );
};
